import React from 'react';
import {Circle} from "@mui/icons-material";
import {Grid} from "@mui/material";
import {capitalizeFirstLetter, getUserHash} from "../framework/utils";

export function AssignmentReplies(props) {

  const {username, hash} = getUserHash();

  const isSelf = (u) => {
    return u == username;
  }

  return (
    <Grid container={1} spacing={0}>
      {props.replies.map(reply => (
        <div className={"u-paddingT10 u-width100 App-assignment-reply"}>
          <Grid item xs={12} md={12}>
            <span className={"u-marginR10 " + (isSelf(reply.username) ? "u-colorAdwiseBlue" : "u-colorDimmed")}>
              <Circle style={{verticalAlign: 'middle', height:32, width:32}} />
            </span>
            Kommentar från {capitalizeFirstLetter(reply.username)}
          </Grid>
          <Grid item xs={12} md={12}>
            {reply.text}
          </Grid>
        </div>
      ))}
    </Grid>
  );
}
